/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import * as React from "react";
import type { SVGIconProps } from "../../svgIconProps";
import { IconSize } from "../../iconTypes";
import { SVGIconContainer } from "../../svgIconContainer";

export const Trash: React.FC<SVGIconProps> = React.forwardRef<any, SVGIconProps>(({size = IconSize.STANDARD, ...props}, ref) => {
    const isLarge = size! >= IconSize.LARGE;
    const pixelGridSize = isLarge ? IconSize.LARGE : IconSize.STANDARD;
    const translation = `${-1 * pixelGridSize / 0.014705882352941176 / 2}`;
    const style = { transformOrigin: "center" };
    return (
        <SVGIconContainer iconName="trash" ref={ref} size={size} {...props}>
            <path
                d={isLarge ? "M623.3333333333333 906.6666666666669V396.6666666666668H510V906.6666666666669H623.3333333333333zM850 906.6666666666669V396.6666666666668H736.6666666666666V906.6666666666669H850zM850 1133.3333333333333H1133.3333333333333V1020H1076.6666666666665V283.3333333333335C1076.6666666666665 252.1666666666668 1065.56 225.5333333333333 1043.3466666666666 203.3200000000002A109.0833333333333 109.0833333333333 0 0 0 963.3333333333331 170H283.3333333333333V1020H226.6666666666667V1133.3333333333333H510V1246.6666666666667H850V1133.3333333333333zM396.6666666666667 283.3333333333335H963.3333333333331V1020H396.6666666666667V283.3333333333335z" : "M498.6666666666667 725.3333333333333V317.3333333333333H408V725.3333333333333H498.6666666666667zM680 725.3333333333333V317.3333333333333H589.3333333333334V725.3333333333333H680zM680 906.6666666666666H906.6666666666669V816H861.3333333333334V226.6666666666667C861.3333333333334 201.7333333333332 852.448 180.4266666666666 834.6773333333333 162.656A87.2666666666667 87.2666666666667 0 0 0 770.6666666666667 136H226.6666666666667V816H181.3333333333334V906.6666666666666H408V997.3333333333334H680V906.6666666666666zM317.3333333333334 226.6666666666667H770.6666666666667V816H317.3333333333334V226.6666666666667z"}
                fillRule="evenodd"
                transform={`scale(0.014705882352941176, -0.014705882352941176) translate(${translation}, ${translation})`}
                style={style}
            />
        </SVGIconContainer>
   );
});
Trash.displayName = `Blueprint5.Icon.Trash`;
export default Trash;
